import type { FeedItem as FeedItemType } from '@whispers/sdk';
import { Link } from 'react-router-dom';

import { Button } from '../Button.js';
import { DeckCardImage } from '../DeckCardImage.js';
import { FeedItem } from './FeedItem.js';

type ReadingFeedItemProps = { item: Extract<FeedItemType, { type: 'reading' }> };

export const ReadingFeedItem = ({ item }: ReadingFeedItemProps) => (
  <FeedItem label="Reading" occurredAt={item.occurredAt}>
    <div>
      <div className="flex min-h-28 items-center justify-center gap-2 sm:gap-4">
        {item.reading.cards.map((card) => (
          <Link
            key={card.id}
            to={`/decks/${card.deckSlug}/cards/${card.slug}`}
            className="w-16 transition-transform hover:-translate-y-1 sm:w-20"
            aria-label={`View ${card.name}`}
          >
            <DeckCardImage
              className="w-full"
              slug={card.slug}
              deckSlug={card.deckSlug}
              name={card.name}
            />
          </Link>
        ))}
      </div>
      <p className="mt-3 text-center text-xs text-text-secondary">
        Tap a card to learn more about it.
      </p>
      <p className="mt-3 text-center text-sm font-medium text-text">
        {item.reading.cards.map((card) => card.name).join(' · ')}
      </p>
      <Button href={`/readings/${item.reading.id}`} variant="secondary" className="mt-5 w-full">
        View full reading
      </Button>
    </div>
  </FeedItem>
);
